// The official Black Leaf Dahlia Society hero seal (provided by Debbie).
// Used on the BL login, topbar, dashboard, and as the seal of the Bloom
// Keeper when running in "blackleaf-dark" mode.
export const BL_HERO_LOGO =
  "https://customer-assets.emergentagent.com/job_bloom-keeper-1/artifacts/44a4sdzb_file_000000005484720ba83ed47f2face60b.png";
